import styled from "styled-components";

import { foundationColors } from "@/v1/themes/colors";

const LINE = foundationColors["deep-purple-100"];

/** Height of an open preview, as the customer Documents tab uses. */
export const PREVIEW_HEIGHT = 400;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 8px 16px;
`;

export const GroupCard = styled.section`
  background: ${foundationColors.white};
  border: 1px solid ${LINE};
  border-radius: 8px;
`;

export const GroupTitle = styled.h3`
  border-bottom: 1px solid ${LINE};
  color: ${foundationColors["base-deep-purple"]};
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  padding: 12px 16px;
`;

export const Field = styled.div`
  padding: 12px 16px;

  & + & {
    border-top: 1px solid ${LINE};
  }
`;

export const FieldHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

export const FieldName = styled.span`
  color: ${foundationColors["base-deep-purple"]};
  font-weight: 600;
`;

/* Pushes the upload button to the right edge of the field header. */
export const FieldAction = styled.div`
  margin-left: auto;
`;

export const FileList = styled.ul`
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
`;

export const FileRow = styled.li`
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 0 12px;
  padding: 2px 0;

  /* A long file name ellipsizes instead of pushing the meta off the row. */
  .ant-btn-link {
    height: auto;
    max-width: min(520px, 100%);
    overflow: hidden;
    padding: 0;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

/* The file's preview, a full-width block below its name and meta. */
export const Preview = styled.div`
  border: 1px solid ${LINE};
  border-radius: 8px;
  flex-basis: 100%;
  margin: 8px 0;
  overflow: hidden;
`;

export const PreviewLoading = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${PREVIEW_HEIGHT}px;
`;

/** Text for assistive technology only, hidden from sighted users. */
export const VisuallyHidden = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const DeleteDialogText = styled.p`
  margin-bottom: 16px;
`;
